import React from 'react';

const DashboardCard = ({ title, value, icon, color, sub }) => {
    // color is a Tailwind border class like "border-green-500"
    // derive a soft bg from it
    const colorMap = {
        'border-green-500':  { accent: '#16a34a', bg: '#f0fdf4', text: '#15803d' },
        'border-blue-500':   { accent: '#2563eb', bg: '#eff6ff', text: '#1d4ed8' },
        'border-indigo-500': { accent: '#4f46e5', bg: '#eef2ff', text: '#4338ca' },
        'border-red-500':    { accent: '#dc2626', bg: '#fef2f2', text: '#b91c1c' },
        'border-yellow-500': { accent: '#d97706', bg: '#fffbeb', text: '#b45309' },
        'border-orange-500': { accent: '#ea580c', bg: '#fff7ed', text: '#c2410c' },
        'border-purple-500': { accent: '#7c3aed', bg: '#f5f3ff', text: '#6d28d9' },
        'border-pink-500':   { accent: '#db2777', bg: '#fdf2f8', text: '#be185d' },
        'border-teal-500':   { accent: '#0d9488', bg: '#f0fdfa', text: '#0f766e' },
        'border-slate-500':  { accent: '#64748b', bg: '#f8fafc', text: '#475569' },
    };

    const scheme = colorMap[color] || { accent: '#5b6af0', bg: '#eef0fd', text: '#4a58e8' };

    return (
        <div className="bg-white rounded-erp border border-erp-border shadow-erp-card flex items-center gap-4 p-4 hover:shadow-erp-card-hover transition-shadow">
            {/* Icon area */}
            <div
                className="w-10 h-10 rounded-erp flex items-center justify-center text-xl flex-shrink-0"
                style={{ background: scheme.bg, color: scheme.accent }}
            >
                {icon}
            </div>

            {/* Text */}
            <div className="min-w-0">
                <p className="text-xs font-semibold uppercase tracking-wide text-erp-text-3 truncate">{title}</p>
                <p className="text-xl font-bold text-erp-text mt-0.5 truncate">{value}</p>
                {sub && <p className="text-xs text-erp-text-3 mt-0.5">{sub}</p>}
            </div>

            {/* Color accent strip */}
            <div
                className="w-0.5 h-8 rounded-full ml-auto flex-shrink-0"
                style={{ background: scheme.accent }}
            />
        </div>
    );
};

export default DashboardCard;
